import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class FilterLabelText extends BaseOption {
  static userInterfaceComponent = {
    label: "Filter Label",
    component: inspectorTools.SIMPLE_INPUT,
    useVerticalOrientation: true,
    descriptionMessage: "Text shown next to the filter icon. Leave blank to hide.",
  };

  static defaultValue = "Filters";
}
